import React from "react";
import { Link } from "react-router-dom";

import data from "../../../../_data/resources-and-reusables.json";
import { isActive } from "../../lib/nav.js";

export default function ResourcesAndReusables() {
  const hero = data?.hero;
  const navItems = data?.nav;

  if (!hero || !navItems) {
    return (
      <section className="resources-and-reusables">
        <div className="empty">Resources and Reusables data not found.</div>
      </section>
    );
  }

  return (
    <section className="resources-and-reusables">
      <div className="hero">
        <div className="heroLeft">
          <h1 className="heroTitle">{hero.title}</h1>
          <p className="heroDesc">{hero.description}</p>

          <div className="heroRight" aria-hidden="true">
            <div
              className="heroArt"
              style={{
                backgroundImage: `url(${hero.heroImage})`,
              }}
              role="img"
              aria-label={hero.heroImageAlt || "Hero art"}
            />
          </div>
        </div>
        <div className="hero-patterns" aria-hidden="true">
          <img src="/assets/img/banner.png" alt="" className="hero-pattern-image" />
        </div>
      </div>

      <div className="sectionContentContainer">
        <div className="sectionContentNav">
          {navItems.map((item, index) => (
            <li
              key={`${item.name}-${index}`}
              className={`sectionContentItem ${isActive(item.href) ? "item-selected" : ""}`}
            >
              <Link to={item.href}>{item.name}</Link>
            </li>
          ))}
        </div>
      </div>
    </section>
  );
}
